module.exports = __webpack_public_path__ + "img/isotipo-creditu.ce168bf5.png";